<template>
    <b-card no-body>
        <b-card-body>
            <template v-if="subgrupo && subgrupo.descricao">
                <template class="subgrupo-descricao">
                    {{ subgrupo.descricao }}
                </template>
            </template>
            <b-card bg-variant="light" data-manual-filter :body-class="filtersOpen ? '' : 'lg-filter-collapsed'">
                <button type="button"
                    class="btn btn-outline-primary lg-filter-toggle w-100 d-flex justify-content-between align-items-center mb-2"
                    @click="toggleFilters">
                    <span class="d-flex align-items-center">
                        <b-icon icon="funnel" font-scale="1.1" class="mr-2"></b-icon>
                        <span>Filtros</span>
                    </span>
                    <b-icon :icon="filtersOpen ? 'chevron-up' : 'chevron-down'" font-scale="1.1"></b-icon>
                </button>

                <div class="lg-filter-container" v-show="filtersOpen">
                    <b-form-row @keyup.enter="load" class="align-items-center">
                        <b-col lg="2" sm="12" class="text-left">
                            <lg-form-const-select label="Situação:" v-model="form.situacao"
                                :options="form.optionsFilterSituacao" @change="load" />
                        </b-col>

                        <b-col lg="6" sm="12" class="text-left">
                            <lg-form-input v-model="form.descricao" label="Nº/Descrição" description=" " />
                        </b-col>

                        <b-col lg="4" sm="12" class="text-right d-flex justify-content-end align-items-center">
                            <b-button class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                                @click="load" id="searchClass-button">
                                <b-tooltip :target="'searchClass-button'" title="Localizar"></b-tooltip>
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" />
                                </div>
                            </b-button>

                            <b-button class="ml-3 mr-2 my-2" style="height: 20px" @click="showClasseModal(subgrupo)"
                                size="sm" pill variant="primary" id="addClass-button"
                                v-if="addBtnVisible && temPrivilegioCriacao()">
                                <b-tooltip :target="'addClass-button'" title="Adicionar novo..."></b-tooltip>
                                <div class="btn-size-alinhamento">
                                    <b-icon scale="1" icon="plus" />
                                </div>
                            </b-button>
                        </b-col>
                    </b-form-row>
                </div>
            </b-card>

            <b-card bg-variant="light" class="mt-2">
                <b-table responsive small :busy="busy" :items="records" :fields="tableFields" :filter="filtro"
                    :hover="true" @row-dblclicked="classeSelect" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Carregando...</strong>
                        </div>
                    </template>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template v-slot:cell(descricao)="{ item }">
                        <p class="mb-0" style="font-size: 13px">{{ item.descricao }}</p>
                    </template>

                    <template v-slot:cell(migrarClasse)="row">
                        <b-button :disabled="!temPrivilegioAlterarClasse()" :id="row.index + 'migrateClass-button'"
                            class="my-2" size="sm" pill variant="primary" @click="desenvolvimento(row.item)">
                            <b-icon icon="folder-symlink" />
                            <b-tooltip :target="row.index + 'migrateClass-button'" title="Migrar Classe..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(local)="row">

                        <b-button :disabled="!temPrivilegioLocalProibido()" :id="row.index + 'proibido-classe-button'"
                            class="my-2" size="sm" pill variant="primary" @click="clickMostrarModalProibido(row.item)">
                            <b-icon icon="x-circle-fill" />
                            <b-tooltip :target="row.index + 'proibido-classe-button'"
                                title="Locais Proibidos..."></b-tooltip>
                        </b-button>

                    </template>
                    <template v-slot:cell(editarClasse)="row">

                        <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'editClass-button'" class="my-2"
                            size="sm" pill variant="primary" @click="editarClasse(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'editClass-button'" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(situacao)="row">
                        <div :id="row.index + 'switchClass'">
                            <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="row.item.situacao" switch
                                size="lg" :value="1" :unchecked-value="0" @change="alteraSituacao(row.item)" />
                            <b-tooltip :target="row.index + 'switchClass'" title="Ativar/Inativar..."></b-tooltip>
                        </div>
                    </template>
                </b-table>
            </b-card>

            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
                        totalPage }} -
                        {{ total }} registros</b-col>
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                            :options="perPageOptions">
                        </b-form-select>
                    </b-col>
                </b-col>
                <b-col cols="6">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                            :total-rows="total"></b-pagination>
                    </div>
                </b-col>
            </b-row>

            <classe-form v-if="showModalClasseForm" @close="cancelar" :prefix="prefix + title + ' > '"
                :id="currentClasseId" :subgrupo="subgrupo" :disabled="disabled" />
        </b-card-body>
        <ModaLocalProibidoClasse v-if="mostrarLocalProibido" :prefix="[prefix + title]" :id="id"
            @close="closeMostrarModalProibido" />
    </b-card>
</template>

<script>
import ClasseService from "@/core/api/ClasseService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import ClasseForm from "./ClasseForm.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModaLocalProibidoClasse from "@/core/components/Modals/ModaLocalProibidoClasse.vue"

export default {
    name: "ClasseList",
    components: {
        ClasseForm,
        ModaLocalProibidoClasse,
        LgFormInput,
        LgFormConstSelect,
    },

    mixins: [ConfirmMixin, ListResourceMixin],

    props: {
        onDblClickClasse: Function,
        apenasConsumo: { type: Boolean, default: null },
        subgrupo: {
            type: [Object, null],
            default: null,
        },
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Classe"
        },

        addBtnVisible: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            mostrarLocalProibido: false,
            disabled: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            showModalClasseForm: false,
            numeroClasseFmt: "",
            subgrupoData: {},
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { value: null, text: "Todos" },
                    { value: 1, text: "Ativo" },
                    { value: 0, text: "Inativo" },
                ],
            },
            currentClasseId: null,
            records: [],
            busy: false,
            page: 1,
            totalPage: 0,
            total: 0,
            filtersOpen: true,
        }
    },

    watch: {
        page() {
            this.load()
        },
    },

    beforeMount() {
        this.$ClasseService = new ClasseService()
        this.subgrupoData = this.subgrupo
    },

    mounted() {
        this.load()
    },

    computed: {

        tableFields() {
            return [
                {
                    key: "numeroClasseFmt",
                    label: "Nº",
                    thStyle: "width: 3rem; font-size: 16px;",
                    tdClass: "text-left",
                },
                {
                    key: "descricao",
                    label: "Descrição",
                    thStyle: "width: 18rem; font-size: 16px;",
                    tdClass: "text-left",
                },
                {
                    key: "migrarClasse",
                    label: "",
                    tdClass: "text-center",
                    thClass: "text-right",
                    thStyle: "font-size: 16px; width: 2rem;",
                },
                {
                    key: "local",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },

                {
                    key: "editarClasse",
                    label: "",
                    tdClass: "text-center",
                    thClass: "text-right",
                    thStyle: "font-size: 16px; width: 2rem;",
                },
                {
                    key: "situacao",
                    label: "",
                    tdClass: "text-center",
                    thClass: "text-right",
                    thStyle: "font-size: 16px; width: 2rem;",
                },
            ]
        },
    },

    methods: {
        toggleFilters() {
            this.filtersOpen = !this.filtersOpen
        },
        clickMostrarModalProibido(item) {
            this.id = item.id;
            this.mostrarLocalProibido = true;
        },
        closeMostrarModalProibido() {
            this.id = null;
            this.mostrarLocalProibido = false;
            this.load();
        },

        temPrivilegioLocalProibido() {
            return verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_PODE_INSERIR_LOCAIS_NAO_AUTORIZADOS);

        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_EDITAR);

        },
        temPrivilegioCriacao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_INCLUIR);

        },
        temPrivilegioAlterarClasse() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALTERAR_CLASSE_PRODUTO);

        },

        async load() {
            this.busy = true
            try {
                let response
                if (this.subgrupo != null) {
                    response = await this.$ClasseService.findBySubgrupoId({
                        size: this.perPage,
                        page: this.page,
                        descricao: this.form.descricao,
                        situacao: this.form.situacao,
                        subgrupoNumero: this.subgrupo.id,
                    })
                } else {
                    response = await this.$ClasseService.findAll({
                        size: this.perPage,
                        page: this.page,
                        descricao: this.form.descricao,
                        situacao: this.form.situacao,
                        apenasConsumo: this.apenasConsumo
                    })
                }
                this.records = response.data.content
                this.total = response.data.totalElements
                this.totalPage = response.data.totalPages
                this.records.forEach(item => {
                    item.numeroClasseFmt = `${item.subgrupoProduto.numeroFmt}.${item.numero}`
                })
            } catch (error) {
                console.error("Error loading classes:", error)
            } finally {
                this.busy = false
            }
        },

        showClasseModal() {
            this.disabled = false;
            this.currentClasseId = null;
            this.showModalClasseForm = true;
        },

        async alteraSituacao(item) {
            let response
            if (item.situacao === 1) {
                response = await this.$confirm(
                    `Deseja ativar o registro?`,
                    item.descricao.toUpperCase()
                )
            } else if (item.situacao === 0) {
                response = await this.$confirm(
                    `Deseja desativar o registro?`,
                    item.descricao.toUpperCase()
                )
            }

            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },

        async confirmarAlteracaoSituacao(item) {
            await this.$ClasseService.alteraSituacao(item).then(response => {
                if (response.status === 200) {
                    this.notify({
                        title: "Sucesso",
                        message: "Registro alterado com sucesso",
                        type: "success",
                    })
                } else {
                    this.notify({
                        title: "Erro",
                        message: "Ocorreu um erro na alteração do registro",
                        type: "danger",
                    });
                }
            })
        },

        editarClasse(classe) {
            this.disabled = true;
            this.currentClasseId = classe.id
            this.showModalClasseForm = true
        },

        classeSelect(classe) {
            this.$emit("onDblClickClasse", classe)
        },

        cancelar() {
            this.currentClasseId = null
            this.showModalClasseForm = false
            this.showModal = false
            this.$emit("close")
            this.load()
        },

        desenvolvimento() {
            this.notify({
                message: "Em desenvolvimento...",
                type: "danger",
            })
        },
    },
}
</script>

<style>
.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
